// React & Hooks
import { useState, useContext } from "react";

// MUI Components
import { IconButton, Stack, Box, Tooltip } from "@mui/material";

// Icons
import { MdDelete, MdModeEdit } from "react-icons/md";

// Project Styles & Components
import "../../../Style/actionstyle.scss";
import TeachingTimeForm from "./TeachingTimeForm";
import DialogDelete from "../../../Utils/DialogDelete";

// Context & GraphQL
import { AuthContext } from "../../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import { DELETE_TEACHING_TIME } from "../../../Schema/TeachingTime";

export default function TeachingTimeAction({ classId, editData, setRefetch }) {
  const { t, setAlert } = useContext(AuthContext);

  // Edit Modal
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  // Delete Dialog
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);

  // Delete mutation
  const [deleteTeachingTime] = useMutation(DELETE_TEACHING_TIME, {
    onCompleted: ({ deleteTeachingTime }) => {
      setLoading(false);
      if (deleteTeachingTime?.isSuccess) {
        setAlert(true, "success", deleteTeachingTime?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteTeachingTime?.message);
      }
    },
    onError: (error) => {
      console.error("Delete error:", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteTeachingTime({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="flex-end">
        <Tooltip title={t("update") || "Update"} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete") || "Delete"} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {/* Edit Modal */}
      {openEdit && (
        <TeachingTimeForm
          open={openEdit}
          classId={classId}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
          handleClose={handleCloseEdit}
        />
      )}

      {/* Delete Confirmation */}
      {openDel && (
        <DialogDelete
          open={openDel}
          loading={loading}
          editData={editData}
          handleClose={handleCloseDel}
          deleteTitle={t("modal_title_delete_teaching_time")}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
}
